<template>
	<div class="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm flex items-center justify-center z-40 p-4">
		<div class="popup-bg rounded-xl shadow-2xl w-full max-w-xl p-6 relative animate-scale-in h-[80vh] overflow-y-auto">
			<button @click="$emit('close')" class="absolute top-4 right-4 p-2 rounded-full hover:bg-[var(--hover-bg-color)] transition">
				<img :src="currentTheme==='dark'||currentTheme==='navy' ? darkX : lightX" alt="Close" class="w-4 h-4"/>
			</button>

			<h1 class="text-3xl font-archivomedium my-4 text-center text-[var(--text-color)]">
				Deposit ZAR
			</h1>

			<h2 class="text-xl font-archivoregular my-4 text-center text-[var(--text-color)]">
				ZAR → USDT
			</h2>
			<!--<p class="text-sm text-[var(--text-color)] mb-4 text-center px-6">
				Deposit ZAR and use Cardware Partner Products to purchase industry leading stablecoins
			</p>-->

			<!-- ─── PLEASE NOTE NOTICE ─── -->
			<div class="mb-6 mt-2 px-4">
				<p class="font-archivomedium mb-3 text-[var(--text-color)] px-4">
					Please note:
				</p>
				<ul class="space-y-2 text-sm text-[var(--text-color)] font-archivolight px-4">
					<li class="flex items-start">
						<span class="flex-shrink-0 mt-1 inline-flex items-center justify-center w-5 h-5 rounded-full bg-blue-100 text-blue-600 mr-2">
							<svg xmlns="http://www.w3.org/2000/svg" class="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
								<path fill-rule="evenodd" d="M16.707 5.293a1 1 0 01.083 1.32l-.084.094L8.414 15l-4.707-4.707a1 1 0 011.32-1.497l.094.083L8.414 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"/>
							</svg>
						</span>
						Important: Deposit only from a bank account in your name.
					</li>
					<li class="flex items-start">
						<span class="flex-shrink-0 mt-1 inline-flex items-center justify-center w-5 h-5 rounded-full bg-blue-100 text-blue-600 mr-2">
							<svg xmlns="http://www.w3.org/2000/svg" class="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
								<path fill-rule="evenodd" d="M16.707 5.293a1 1 0 01.083 1.32l-.084.094L8.414 15l-4.707-4.707a1 1 0 011.32-1.497l.094.083L8.414 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"/>
							</svg>
						</span>
						Don’t deposit the same amount more than once per day.
					</li>
					<li class="flex items-start">
						<span class="flex-shrink-0 mt-1 inline-flex items-center justify-center w-5 h-5 rounded-full bg-blue-100 text-blue-600 mr-2">
							<svg xmlns="http://www.w3.org/2000/svg" class="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
								<path fill-rule="evenodd" d="M16.707 5.293a1 1 0 01.083 1.32l-.084.094L8.414 15l-4.707-4.707a1 1 0 011.32-1.497l.094.083L8.414 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"/>
							</svg>
						</span>
						No cash. No Cheques. Only EFTs accepted.
					</li>
					<li class="flex items-start">
						<span class="flex-shrink-0 mt-1 inline-flex items-center justify-center w-5 h-5 rounded-full bg-blue-100 text-blue-600 mr-2">
							<svg xmlns="http://www.w3.org/2000/svg" class="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
								<path fill-rule="evenodd" d="M16.707 5.293a1 1 0 01.083 1.32l-.084.094L8.414 15l-4.707-4.707a1 1 0 011.32-1.497l.094.083L8.414 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"/>
							</svg>
						</span>
						South African bank accounts only for deposits.
					</li>
					<!-- red‐X item -->
					<li class="flex items-start space-x-2">
						<div class="flex-shrink-0 w-5 h-5 flex items-center justify-center bg-red-100 text-red-600 rounded-full">
							<svg class="w-2 h-2" fill="currentColor" viewBox="0 0 8 8">
								<path d="M1 1l6 6m0-6L1 7" stroke="currentColor" stroke-width="1"/>
							</svg>
						</div>
						<span>Using an incorrect reference may result in a delay or loss of funds.</span>
					</li>
				</ul>
			</div>

			<!-- REFERENCE BOX -->
			<div class="border border-[var(--accent-color)] bg-[var(--accent-color-10)] rounded-lg p-4 mb-6 text-center">
				<p class="text-sm text-[var(--text-color)] mb-1">
					Deposit using this reference:
				</p>
				<p class="text-xl font-archivosemibold text-[var(--accent-color)] break-words">
					{{ props.depositReference }}
				</p>
			</div>

			<!-- BANK DETAILS -->
			<h2 class="text-xl font-archivomedium mt-6 mb-2 text-[var(--text-color)]">
				Bank Details
			</h2>
			<div class="bg-[var(--accent-color-10)] border border-[var(--border-color)] rounded-lg p-4 mb-4">
				<div class="grid grid-cols-2 gap-2 text-sm text-[var(--text-color)]">
					<div>
						<span class="text-[var(--account-block-text-color)] font-archivoregular">Bank Name: </span>
						<strong>{{ bank.bankName }}</strong>
					</div>
					<div>
						<span class="text-[var(--account-block-text-color)] font-archivoregular">Account Number: </span>
						<strong>{{ bank.accountNumber }}</strong>
					</div>
					<div>
						<span class="text-[var(--account-block-text-color)] font-archivoregular">Branch Number: </span>
						<strong>{{ bank.branchNumber }}</strong>
					</div>
					<div>
						<span class="text-[var(--account-block-text-color)] font-archivoregular">Type of Account: </span>
						<strong>{{ bank.accountType }}</strong>
					</div>
					<div>
						<span class="text-[var(--account-block-text-color)] font-archivoregular">Recipient: </span>
						<strong>{{ bank.recipient }}</strong>
					</div>
					<div>
						<span class="text-[var(--account-block-text-color)] font-archivoregular">Your Reference: </span>
						<strong>{{ props.depositReference }}</strong>
					</div>
				</div>
			</div>

			<!-- WITHDRAWAL ADDRESS -->
			<h2 class="text-xl font-archivomedium mt-10 mb-2 text-[var(--text-color)]">
				Withdrawal Address
			</h2>

			<div v-if="!selectedWithdrawal" class="flex justify-start mb-4">
				<button @click="openWithdrawal" class="px-4 py-2 text-[var(--text-color)] text-sm hover:text-[var(--accent-color)] hover:underline font-archivolight transition disabled:opacity-80 disabled:cursor-not-allowed">
					Choose Address
				</button>
			</div>

			<div v-else class="mb-4 p-4 bg-[var(--accent-color-10)] border border-[var(--border-color)] rounded-lg">
				<p class="text-sm text-[var(--text-color)] break-all">
					<strong>{{ selectedWithdrawal.name }}</strong>  {{ selectedWithdrawal.address }}
				</p>
			</div>

			<!-- TERMS & CONDITIONS  -->
			<h2 class="text-md font-archivomedium mt-10 mb-2 text-[var(--text-color)]">
				Terms &amp; Conditions
			</h2>
			<div class="bg-[var(--account-bg)] border border-[var(--border-color)] rounded-lg p-4 mb-4 h-32 overflow-y-auto text-xs text-[var(--text-color)] font-archivolight">
				<p>{{ termsText }}</p>
			</div>
			<div class="flex items-center mb-6">
				<input id="acceptTerms" type="checkbox" v-model="accepted" class="mr-2"/>
				<label for="acceptTerms" class="text-[var(--text-color)] text-sm">Accept T’s & C’s</label>
			</div>

			<button @click="goToConfirm" :disabled="!accepted || !selectedWithdrawal" class="w-full py-2 mt-2 mb-10 rounded-full bg-[var(--accent-color)] text-white font-archivomedium border border-[var(--accent-color)] hover:bg-transparent hover:text-[var(--accent-color)] transition disabled:opacity-50 disabled:cursor-not-allowed">
				I have transferred the funds
			</button>

			<WithdrawalAddressPopup
				v-if="showWithdrawalAddressPopup"
				:current-theme="currentTheme"
				:evm-accounts="evmAccounts"
				:initial-selected="withdrawalAddress"
				@close="showWithdrawalAddressPopup = false"
				@add-account="onAddAccount"
				@confirm-withdrawal-address="onSelectWithdrawal"
			/>
		</div>
	</div>
</template>

<script setup>
	import { ref, watch } from 'vue';
	//import QRCodeVue from 'qrcode.vue';
	import lightX from '../assets/X.png';
	import darkX from '../assets/XWhite.png';
	import WithdrawalAddressPopup from './withdrawalAddressPopup.vue';

	const props = defineProps({ currentTheme: String, walletAddress: String, evmAccounts: Array, depositReference: String, withdrawalAddress: Object});
	const emit = defineEmits(['close','next','add-account']);

	const bank = { bankName:'Standard Bank', accountNumber:'001624849', branchNumber:'051001', accountType:'Current / Cheque', recipient:'Cardware', yourReference:'YourRef' };

	const termsText = ref('Your terms and conditions go here Your terms and conditions go here Your terms and conditions go here Your terms and conditions go here Your terms and conditions go hereYour terms and conditions go here Your terms and conditions go hereYour terms and conditions go here Your terms and conditions go here Your terms and conditions go here Your terms and conditions go here Your terms and conditions go here Your terms and conditions go here Your terms and conditions go here Your terms and conditions go here Your terms and conditions go here...');
	const accepted = ref(false);

	const showWithdrawalAddressPopup = ref(false);

	const selectedWithdrawal = ref(props.withdrawalAddress || null);
	
	watch(() => props.withdrawalAddress, val => {
		selectedWithdrawal.value = val || null;
	});

	function openWithdrawal() { 
		showWithdrawalAddressPopup.value = true; 
	}

	function onSelectWithdrawal(acc) { 
		selectedWithdrawal.value = acc; 
		showWithdrawalAddressPopup.value = false; 
	}

	function confirmDeposit() { 
		emit('confirm', selectedWithdrawal.value); 
	}

	function goToConfirm() {
		emit('next', selectedWithdrawal.value);
	}

	function onAddAccount() { 
		emit('add-account'); 
	}

</script>

<style scoped>
	.popup-bg { background: var(--popup-bg-color); }
	.account-bg { background: var(--account-bg-block-color); }
	.fade-enter-active, .fade-leave-active { transition: opacity .2s ease; }
	.fade-enter-from, .fade-leave-to { opacity: 0; }
</style>